import { AUTO_STEP_NAME, PRODUCTS, STEPS } from 'domain/enums'
import { LeadsContext } from 'homepage/presentation/components/LeadsContext'
import { useCallback, useContext, useEffect, useState } from 'react'
import { useQuery } from 'shared/application/hooks/useQuery.hook'

export const useFilters = () => {
  const queryPath = useQuery()
  const [productType, setProductType] = useState(
    queryPath.get('productType') || 'HOME_REFI',
  )

  const [date, setDate] = useState(queryPath.get('date'))
  const [stepName, setStepName] = useState(queryPath.get('stepName') || '')
  const [situation, setSituation] = useState(queryPath.get('situation') || '')

  const mountOptions = list => {
    const newList = [['ALL', 'Todas'], ...list]

    return newList.map(item => {
      const option = { value: item[0], text: item[1] }

      return option
    })
  }

  const collateralItems = value => mountOptions(Object.entries(value))

  const {
    isLoading: loading,
    changeSearch,
    changeFilters,
  } = useContext(LeadsContext)

  const handleSearch = value => {
    changeSearch({ query: value })
  }

  const handleCollateralFilter = value => {
    setProductType(value.value === 'ALL' ? '' : value.value)
    setStepName('')
  }

  const handleDateFilter = value => {
    setDate(value.value === 'ALL' ? 0 : value.value)
    changeSearch({ date: value.value === 'ALL' ? 0 : value.value })
  }

  const handleStatusFilter = value => {
    setSituation(value.value === 'ALL' ? '' : value.value)
  }

  const handleChangeFilter = useCallback(() => {
    changeFilters(productType, stepName, situation)
  }, [productType, stepName, situation])

  const handleCollateralStep = value => {
    switch (value.text) {
      case productType !== PRODUCTS.HOME_FIN && STEPS.CREDIT_ANALYSIS:
        setStepName(
          value.value === 'ALL'
            ? ''
            : `${value.value}, ${AUTO_STEP_NAME.LOAN_PROPOSAL_ANALYSIS}`,
        )
        break
      case productType !== PRODUCTS.HOME_FIN &&
        STEPS.DOCUMENTS_COLLATERAL_INSPECTION:
        setStepName(
          value.value === 'ALL'
            ? ''
            : `${AUTO_STEP_NAME.COLLATERAL_INSPECTION}, ${AUTO_STEP_NAME.DOCUMENTS}`,
        )
        break

      default:
        setStepName(value.value === 'ALL' ? '' : value.value)
    }
  }

  const stepQueryParam =
    queryPath.get('stepName') !== '' && queryPath.get('stepName') !== null
      ? queryPath.get('stepName').split(',')[0]
      : ''

  useEffect(() => {
    if (productType === '') {
      setStepName('')
    }
  }, [productType])

  useEffect(() => {
    handleChangeFilter()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleChangeFilter])

  return {
    queryPath,
    productType,
    date,
    loading,
    stepName,
    situation,
    handleSearch,
    collateralItems,
    handleCollateralFilter,
    handleDateFilter,
    handleStatusFilter,
    handleChangeFilter,
    handleCollateralStep,
    stepQueryParam,
  }
}
